// UserGroupsManagementTable.jsx
// import React, { useState, useEffect, useRef } from "react";
// import { useNavigate, Link } from "react-router-dom";
// import Filter from "../../../Assets/Images/CommanImages/filter.png";
// import columnaddition from "../../../Assets/Images/CommanImages/rectangleplus.png";
// import updown from "../../../Assets/Images/CommanImages/updown.png";
// import searchicon from "../../../Assets/Images/CommanImages/searchyellow.png";
// import leftArrow from "../../../Assets/Images/CommanImages/Larrowbar.png";
// import rightArrow from "../../../Assets/Images/CommanImages/Rarrowbar.png";
// import SelectedValuesDropdown from "../../../Components/Shared/SelectedValuesDropdown/SelectDropdown";
// import FileSaver from "file-saver";
// import * as XLSX from "xlsx";
// import jsPDF from "jspdf";
// import "jspdf-autotable";

// const UserGroupsManagementTable = ({
//   headers = [],
//   data = [],
//   searchPlaceholder,
//   dataClient,
//   setPagePath,
//   renderQuestionText,
//   selectedRows,
//   setSelectedRows,
//   bulk = false,
// }) => {
//   const navigate = useNavigate();
//   const [isColumnDivVisible, setIsColumnDivVisible] = useState(false);
//   const [isFilterVisible, setIsFilterVisible] = useState(false);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [visibleColumns, setVisibleColumns] = useState([]);
//   const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
//   const [isModalVisible, setIsModalVisible] = useState(false);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [pageSize, setPageSize] = useState(10);
//   const [averageRunTime, setAverageRunTime] = useState("");
//   const columnDropdownRef = useRef(null);

//   const [filters, setFilters] = useState({}); // Holds current selections
//   const [appliedFilters, setAppliedFilters] = useState({});
//   const [isFiltersApplied, setIsFiltersApplied] = useState(false);
//   const [isFilterDropdownSelected, setIsFilterDropdownSelected] = useState(false);
//   const [columnWidth, setColumnWidth] = useState(400);
//   const columnRef = useRef(null);
//   const isResizing = useRef(false);

//   // === Helpers to safely extract staff number and user id from a row using headers with fallback indices ===
//   const findHeaderIndex = (regexes) => {
//     if (!Array.isArray(headers)) return -1;
//     for (let i = 0; i < headers.length; i++) {
//       const h = (headers[i] || "").toString().trim().toLowerCase();
//       if (!h) continue;
//       for (const rx of regexes) {
//         if (rx.test(h)) return i;
//       }
//     }
//     return -1;
//   };

//   // Staff number (what the search endpoint expects) — prefer columns like "staff", "staff number", "staff_no", "staff number"
//   const getStaffNumberFromRow = (row) => {
//     const idx = findHeaderIndex([/staff\b/, /staff number/, /staff_no/, /staff no/, /staffnumber/]);
//     if (idx !== -1) return row[idx];
//     // fallback to legacy index(2)
//     return row[2];
//   };

//   // User id extraction — prefer headers containing "user id" or "user_id"
//   const getUserIdFromRow = (row) => {
//     const idx = findHeaderIndex([/user id/, /userid/, /user_id/, /user-id/]);
//     if (idx !== -1) return row[idx];
//     // fallback to index 7 (as earlier code did)
//     return row[7];
//   };

//   // Employee internal id (if somewhere needed) — search for 'employee id' explicitly
//   const getEmployeeInternalIdFromRow = (row) => {
//     const idx = findHeaderIndex([/employee id/, /emp id/, /employeeid/, /empid/]);
//     if (idx !== -1) return row[idx];
//     // fallback to index 8 if the newer API placed it there (best-effort)
//     return row[8] ?? row[2];
//   };

//   useEffect(() => {
//     if (headers.length > 0) {
//       const mustHave = ["Role Code"]; // lock this to always show
//       const initial = headers
//         // .filter((h) => !mustHave.includes(h) && h !== "Role ID")
//         .filter((h) => !mustHave.includes(h) && !["Employee Id", "User Id"].includes(h))
//         .slice(0, 5);
//       const initialWithMustHave = headers.filter(
//         // (h) => (mustHave.includes(h) || initial.includes(h)) && h !== "Role ID"
//         (h) =>
//   (mustHave.includes(h) || initial.includes(h)) &&
//   !["Employee Id", "User Id"].includes(h)

//       );
//       setVisibleColumns(initialWithMustHave);
//     }
//   }, [headers]);

//   const handleColumnSelection = (column) => {
//     if (["Role Code"].includes(column)) return; // locked
//     if (visibleColumns.includes(column)) {
//       setVisibleColumns(visibleColumns.filter((c) => c !== column));
//     } else {
//       setVisibleColumns([...visibleColumns, column]);
//     }
//   };

//   const handleSearch = (e) => {
//     setSearchQuery(e.target.value);
//     setCurrentPage(1);
//   };

//   const handleApplyFilter = () => {
//     if (Object.keys(filters).length > 0) {
//       setAppliedFilters({ ...filters }); // Persist selected filters
//       setCurrentPage(1); // Reset to the first page
//       setIsFiltersApplied(true); // Show Reset button
//       setIsFilterVisible(false); // Hide the filter sidebar
//     }
//   };

//   const handleResetFilter = () => {
//     setFilters({}); // Clear current filter selections
//     setAppliedFilters({}); // Clear applied filters
//     setAverageRunTime(""); // Reset any other state if required
//     setIsFiltersApplied(false); // Deactivate the Reset button
//   };

//   const handleFilterSelection = (selectedOption, header) => {
//     setFilters((prevFilters) => ({
//       ...prevFilters,
//       [header]: selectedOption,
//     }));

//     setIsFilterDropdownSelected(true); // Mark dropdown as interacted
//   };

//   const filteredData = data.filter((row) => {
//     const matchesSearchQuery = row.some(
//       (cell) =>
//         cell && String(cell).toLowerCase().includes(searchQuery.toLowerCase())
//     );
//     const matchesAverageRunTime =
//       averageRunTime === "" || row[2] === averageRunTime;

//     // Apply appliedFilters
//     const matchesFilters = Object.entries(appliedFilters).every(
//       ([key, value]) => {
//         const colIndex = headers.indexOf(key);
//         return value ? row[colIndex] === value : true;
//       }
//     );

//     return matchesSearchQuery && matchesAverageRunTime && matchesFilters;
//   });

//   const handleSort = (column) => {
//     let direction = "asc";
//     if (sortConfig.key === column && sortConfig.direction === "asc") {
//       direction = "desc";
//     }
//     setSortConfig({ key: column, direction });
//   };

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (
//         columnDropdownRef.current &&
//         !columnDropdownRef.current.contains(event.target)
//       ) {
//         setIsColumnDivVisible(false); // Close the dropdown if clicked outside
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   const sortedData = React.useMemo(() => {
//     let sortableData = [...filteredData];
//     if (sortConfig.key !== null) {
//       const colIndex = headers.indexOf(sortConfig.key);
//       sortableData.sort((a, b) => {
//         const A = a[colIndex];
//         const B = b[colIndex];
//         if (A < B) return sortConfig.direction === "asc" ? -1 : 1;
//         if (A > B) return sortConfig.direction === "asc" ? 1 : -1;
//         return 0;
//       });
//     }
//     return sortableData;
//   }, [filteredData, sortConfig, headers]);

//   const handleExport = (type) => {
//     const exportData = sortedData.map((row) =>
//       visibleColumns.map((column) => row[headers.indexOf(column)])
//     );

//     const fileName = prompt("Enter the file name:");
//     if (!fileName) return;

//     if (type === "excel" || type === "csv") {
//       const worksheet = XLSX.utils.aoa_to_sheet([visibleColumns, ...exportData]);
//       const workbook = XLSX.utils.book_new();
//       XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
//       const fileExtension = type === "csv" ? "csv" : "xlsx";
//       const mimeType =
//         type === "csv"
//           ? "text/csv"
//           : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
//       const file = XLSX.write(workbook, {
//         bookType: fileExtension,
//         type: "array",
//       });
//       const blob = new Blob([file], { type: mimeType });
//       FileSaver.saveAs(blob, `${fileName}.${fileExtension}`);
//     } else if (type === "pdf") {
//       const doc = new jsPDF();
//       doc.autoTable({
//         head: [visibleColumns],
//         body: exportData,
//       });
//       doc.save(`${fileName}.pdf`);
//     }
//   };

//   const handlePageSizeChange = (size) => {
//     setPageSize(size);
//     setCurrentPage(1);
//   };

//   const handlePageChange = (page) => {
//     setCurrentPage(page);
//   };

//   const totalPages = Math.ceil(sortedData.length / pageSize);
//   const paginatedData = React.useMemo(() => {
//     const startIndex = (currentPage - 1) * pageSize;
//     return sortedData.slice(startIndex, startIndex + pageSize);
//   }, [sortedData, currentPage, pageSize]);

//   const renderPagination = () => {
//     const pages = [];
//     if (totalPages <= 5) {
//       for (let i = 1; i <= totalPages; i++) {
//         pages.push(
//           <button
//             key={i}
//             onClick={() => handlePageChange(i)}
//             style={{ borderRadius: "5px" }}
//             className={i === currentPage ? "active" : ""}
//           >
//             {i}
//           </button>
//         );
//       }
//     } else {
//       if (currentPage <= 3) {
//         for (let i = 1; i <= 3; i++) {
//           pages.push(
//             <button
//               key={i}
//               style={{ borderRadius: "5px" }}
//               onClick={() => handlePageChange(i)}
//               className={i === currentPage ? "active" : ""}
//             >
//               {i}
//             </button>
//           );
//         }
//         pages.push(
//           <span style={{ borderRadius: "5px" }} key="dots1">
//             ...
//           </span>
//         );
//         pages.push(
//           <button
//             key={totalPages}
//             onClick={() => handlePageChange(totalPages)}
//             style={{ borderRadius: "5px" }}
//           >
//             {totalPages}
//           </button>
//         );
//       } else if (currentPage > 3 && currentPage < totalPages - 2) {
//         pages.push(
//           <button
//             key={1}
//             onClick={() => handlePageChange(1)}
//             style={{ borderRadius: "5px" }}
//           >
//             1
//           </button>
//         );
//         pages.push(
//           <span style={{ borderRadius: "5px" }} key="dots1">
//             ...
//           </span>
//         );
//         for (let i = currentPage - 1; i <= currentPage + 1; i++) {
//           pages.push(
//             <button
//               key={i}
//               onClick={() => handlePageChange(i)}
//               style={{ borderRadius: "5px" }}
//               className={i === currentPage ? "active" : ""}
//             >
//               {i}
//             </button>
//           );
//         }
//         pages.push(
//           <span style={{ borderRadius: "5px" }} key="dots2">
//             ...
//           </span>
//         );
//         pages.push(
//           <button
//             key={totalPages}
//             onClick={() => handlePageChange(totalPages)}
//             style={{ borderRadius: "5px" }}
//           >
//             {totalPages}
//           </button>
//         );
//       } else {
//         pages.push(
//           <button
//             key={1}
//             onClick={() => handlePageChange(1)}
//             style={{ borderRadius: "5px" }}
//           >
//             1
//           </button>
//         );
//         pages.push(
//           <span style={{ borderRadius: "5px" }} key="dots1">
//             ...
//           </span>
//         );
//         for (let i = totalPages - 2; i <= totalPages; i++) {
//           pages.push(
//             <button
//               key={i}
//               onClick={() => handlePageChange(i)}
//               style={{ borderRadius: "5px" }}
//               className={i === currentPage ? "active" : ""}
//             >
//               {i}
//             </button>
//           );
//         }
//       }
//     }
//     return pages;
//   };

//   const handleSelectAll = (e) => {
//     if (!bulk) {
//       // If not in bulk mode, don't allow selecting all
//       return;
//     }
//     if (e.target.checked) {
//       setSelectedRows(data.map((row) => row[0]));
//     } else {
//       setSelectedRows([]);
//     }
//   };

//   const handleRowSelect = (rowIndex) => {
//     const actualIndex = (currentPage - 1) * pageSize + rowIndex;
//     const questionId = sortedData[actualIndex][0];

//     setSelectedRows((prev) => (prev.includes(questionId) ? [] : [questionId]));
//   };

//   const handleMouseDown = (event) => {
//     isResizing.current = true;
//     document.addEventListener("mousemove", handleMouseMove);
//     document.addEventListener("mouseup", handleMouseUp);
//   };

//   const handleMouseMove = (event) => {
//     if (isResizing.current) {
//       const newWidth = Math.max(100, event.clientX - columnRef.current.offsetLeft); // Min width: 100px
//       setColumnWidth(newWidth);
//     }
//   };

//   const handleMouseUp = () => {
//     isResizing.current = false;
//     document.removeEventListener("mousemove", handleMouseMove);
//     document.removeEventListener("mouseup", handleMouseUp);
//   };

//   return (
//     <div>
//       <div
//         style={{
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "space-between",
//           marginTop: "10px",
//         }}
//       >
//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//             width: "82vw",
//           }}
//         >
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               border: "1px solid #6A6A6A",
//               overflow: "hidden",
//             }}
//           >
//             <input
//               type="text"
//               placeholder={searchPlaceholder}
//               name="search"
//               className="search-input-ques-dash"
//               onChange={handleSearch}
//             />
//             <div
//               style={{
//                 width: "1px",
//                 height: "24px",
//                 backgroundColor: "#2F2E40",
//                 margin: "0 4px",
//               }}
//             ></div>
//             <img src={searchicon} alt="search" className="search-icon-ques-dash" />
//           </div>
//           <div style={{ textAlign: "end", marginTop: "20px", color: "#424242" }}>
//             Displaying{" "}
//             {Math.min((currentPage - 1) * pageSize + 1, sortedData.length)} -{" "}
//             {Math.min(currentPage * pageSize, sortedData.length)} of {sortedData.length} records |
//             {["10", "25", "50", "100", "500"].map((size) => (
//               <span
//                 key={size}
//                 onClick={() => handlePageSizeChange(Number(size))}
//                 style={{
//                   cursor: "pointer",
//                   margin: "0 5px",
//                   textDecoration: size === pageSize.toString() ? "none" : "underline",
//                   color: size === pageSize.toString() ? "black" : "#337AB7",
//                 }}
//               >
//                 {size}
//               </span>
//             ))}
//           </div>
//         </div>
//       </div>

//       <div
//         style={{
//           display: "flex",
//           backgroundColor: "#D6D6D6",
//           marginTop: "9px",
//           borderTop: "1px solid grey",
//           borderBottom: "1px solid grey",
//         }}
//       >
//         <div
//           style={{
//             backgroundColor: "#FFBD20",
//             display: "flex",
//             alignItems: "center",
//             cursor: "pointer",
//             paddingLeft: "8px",
//             width: "90px",
//           }}
//           onClick={() => setIsFilterVisible(!isFilterVisible)}
//         >
//           <img src={Filter} style={{ height: "24px", width: "24px" }} alt="filter" />
//           <span style={{ marginLeft: "10px", color: "#2F2E40" }}>Filter</span>
//         </div>
//         <div
//           className="col-tc"
//           style={{
//             marginLeft: "auto",
//             textAlign: "end",
//             marginRight: "8px",
//             display: "flex",
//             alignItems: "center",
//             position: "relative",
//             cursor: "pointer",
//             height: "40px",
//           }}
//           onClick={() => setIsColumnDivVisible(!isColumnDivVisible)}
//         >
//           <img src={columnaddition} style={{ height: "34px", width: "32px" }} alt="column addition" />
//           <span
//             style={{
//               marginLeft: "4px",
//               color: "#2F2E40",
//               marginRight: "14px",
//               fontSize: "14px",
//             }}
//           >
//             Column Selection
//           </span>
//           {isColumnDivVisible && (
//             <div ref={columnDropdownRef}>
//               <div className="arrow-up-tc"></div>
//               <div className="popupColumn-tc">
//                 {headers
//                   // .filter((h) => h && h !== "Role ID") // do not offer Role ID
//                    .filter((h) => h && !["Employee Id", "User Id"].includes(h))
//                   .map((column, index) => (
//                     <div
//                       key={index}
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         handleColumnSelection(column);
//                       }}
//                     >
//                       <input
//                         type="checkbox"
//                         id={`column-${index}`}
//                         value={column}
//                         className="square-checkbox-tc"
//                         checked={visibleColumns.includes(column)}
//                         disabled={column === "Role Code"} // cannot hide Role Code
//                         readOnly
//                       />
//                       <label htmlFor={`column-${index}`}>{column}</label>
//                     </div>
//                   ))}
//               </div>
//             </div>
//           )}
//         </div>
//       </div>

//       {data.length > 0 ? (
//         <>
//           <div className="table-container-scrollable">
//             <table className="fixed-header-table" style={{ width: "100%" }}>
//               <thead>
//                 <tr>
//                   {visibleColumns.map((heading, index) => (
//                     <td
//                       key={index}
//                       ref={index === 1 ? columnRef : null}
//                       className={`Heading-tc resizable-header ${index === 1 ? "resizable-header" : ""}`}
//                       style={{
//                         textAlign: "right",
//                         cursor: "pointer",
//                         width: index === 1 ? `${columnWidth}px` : "auto",
//                         position: "relative",
//                       }}
//                     >
//                       <span
//                         style={{
//                           display: "flex",
//                           alignItems: "left",
//                           justifyContent: "left",
//                           color: "rgb(47, 46, 64)",
//                           fontSize: "14px",
//                         }}
//                       >
//                         {heading}
//                         {index === 1 && <div className="resize-handle" onMouseDown={handleMouseDown}></div>}
//                         <img
//                           onClick={() => handleSort(heading)}
//                           src={updown}
//                           style={{ height: "20px", width: "20px", marginLeft: "5px" }}
//                           alt="sort"
//                         />
//                       </span>
//                     </td>
//                   ))}
//                 </tr>
//               </thead>

//               <tbody>
//                 {paginatedData.map((row, rowIndex) => (
//                   <tr key={rowIndex} className={rowIndex % 2 === 1 ? "even-row-tc" : ""}>
//                     {visibleColumns.map((column, cellIndex) => {
//                       const colIndexInHeaders = headers.indexOf(column);
//                       // safe fallback if header not found
//                       const cellValue = colIndexInHeaders !== -1 ? row[colIndexInHeaders] : "";
//                       return (
//                         <td
//                           key={cellIndex}
//                           style={{
//                             width: cellIndex === 1 ? `${columnWidth}px` : "auto",
//                             textAlign: "left",
//                             color: "#6A6A6A",
//                             verticalAlign: "middle",
//                             whiteSpace: "nowrap",
//                             overflow: "hidden",
//                             textOverflow: "ellipsis",
//                             maxWidth: `${columnWidth}px`,
//                           }}
//                         >
//                           {cellIndex === 0 ? (
//                             <div style={{ display: "flex", alignItems: "center" }}>
//                               <input
//                                 type="checkbox"
//                                 className="delete-question-checkbox-dqc"
//                                 checked={selectedRows.includes(row[0])}
//                                 onChange={() => handleRowSelect(rowIndex)}
//                                 style={{ marginRight: "8px" }}
//                               />
//                               {/* NAVIGATE passing staff number (search key) and user id */}
//                               <Link
//                                 style={{ color: "#337ab7" }}
//                                 to={`/user_from_dashboard_edit?MNTQuestionNumbers=${encodeURIComponent(
//                                   getStaffNumberFromRow(row)
//                                 )}&UsernameOfEmployee=${encodeURIComponent(row[0])}&UserID=${encodeURIComponent(
//                                   getUserIdFromRow(row)
//                                 )}`}
//                               >
//                                 <span className="truncated-text" title={cellValue}>
//                                   {colIndexInHeaders === 2 ? renderQuestionText(cellValue) : cellValue}
//                                 </span>
//                               </Link>
//                             </div>
//                           ) : (
//                             <span className="truncated-text-2">
//                               {colIndexInHeaders === 2 ? renderQuestionText(cellValue) : cellValue}
//                             </span>
//                           )}
//                         </td>
//                       );
//                     })}
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>

//           <div className="pagination-tc">
//             <button onClick={() => handlePageChange(1)} disabled={currentPage === 1} className="extreme-left-tc-pagination">
//               <img src={leftArrow} alt="" />
//             </button>
//             <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} className="lefttc-pagination">
//               {"<"}
//             </button>
//             {renderPagination()}
//             <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} className="righttc-pagination">
//               {">"}
//             </button>
//             <button onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} className="extreme-right-tc-pagination">
//               <img src={rightArrow} alt="" />
//             </button>
//           </div>
//         </>
//       ) : (
//         "No data available"
//       )}

//       {isFilterVisible && (
//         <div className="filter-sidebar-tc">
//           <div className="filter-content-tc" style={{ position: "relative" }}>
//             <button className="repman-cross-btn-HOD" onClick={() => setIsFilterVisible(false)}>
//               <p>X</p>
//             </button>
//             <h3 className="AdvanceF-heading-tc"> Filter</h3>
//             <div className="filter-apply-reset-ques-rev-dash">
//               <button className="create-test-section-btn" onClick={handleApplyFilter}>
//                 APPLY
//               </button>
//               {isFiltersApplied && (
//                 <button className="create-test-section-btn" onClick={handleResetFilter}>
//                   RESET
//                 </button>
//               )}
//             </div>
//             <div className="filter-options-container">
//               {headers
//                 // .filter((_, index) => index !== 0) // Skip only index 0
//                 .filter((header) => header && !["Employee Id", "User Id"].includes(header))
//                 .map((header, filteredIndex) => {
//                   const originalIndex = filteredIndex + 1; // Shift by 1 because we skipped index 0

//                   let uniqueOptions = [
//                     ...new Set(data.map((row) => row[originalIndex]).filter((option) => option)),
//                   ];

//                   // Sort index 1 and index 6 in ascending order (adjust if needed)
//                   if (originalIndex === 1 || originalIndex === 6) {
//                     uniqueOptions.sort((a, b) => (a > b ? 1 : -1));
//                   }

//                   return (
//                     <SelectedValuesDropdown
//                       key={originalIndex}
//                       label={header}
//                       width="300px"
//                       marginLeft="15px"
//                       marginTop="18px"
//                       setSelected={(selectedOption) => {
//                         setFilters((prevFilters) => ({
//                           ...prevFilters,
//                           [header]: selectedOption, // Update the filters state
//                         }));
//                       }}
//                       options={uniqueOptions.map((value) => ({
//                         label: value,
//                         id: value,
//                       }))}
//                       selected={filters[header] || ""} // Show selected filter if present
//                       Height="auto"
//                       OverFlow="auto"
//                       minheight="200px"
//                     />
//                   );
//                 })}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default UserGroupsManagementTable;

































import React, { useState, useEffect, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import Filter from "../../../Assets/Images/CommanImages/filter.png";
import columnaddition from "../../../Assets/Images/CommanImages/rectangleplus.png";
import updown from "../../../Assets/Images/CommanImages/updown.png";
import searchicon from "../../../Assets/Images/CommanImages/searchyellow.png";
import leftArrow from "../../../Assets/Images/CommanImages/Larrowbar.png";
import rightArrow from "../../../Assets/Images/CommanImages/Rarrowbar.png";
import SelectedValuesDropdown from "../../../Components/Shared/SelectedValuesDropdown/SelectDropdown";
import FileSaver from "file-saver";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";

const UserGroupsManagementTable = ({
  headers = [],
  data = [],
  searchPlaceholder,
  dataClient,
  setPagePath,
  renderQuestionText,
  selectedRows,
  setSelectedRows,
  bulk = false,
}) => {
  const navigate = useNavigate();
  const [isColumnDivVisible, setIsColumnDivVisible] = useState(false);
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [visibleColumns, setVisibleColumns] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [averageRunTime, setAverageRunTime] = useState("");
  const columnDropdownRef = useRef(null);

  const [filters, setFilters] = useState({}); // Holds current selections
  const [appliedFilters, setAppliedFilters] = useState({});
  const [isFiltersApplied, setIsFiltersApplied] = useState(false);
  const [isFilterDropdownSelected, setIsFilterDropdownSelected] = useState(false);
  const [columnWidth, setColumnWidth] = useState(400);
  const columnRef = useRef(null);
  const isResizing = useRef(false);

  // === Helpers to safely extract staff number and user id from a row using headers with fallback indices ===
  const findHeaderIndex = (regexes) => {
    if (!Array.isArray(headers)) return -1;
    for (let i = 0; i < headers.length; i++) {
      const h = (headers[i] || "").toString().trim().toLowerCase();
      if (!h) continue;
      for (const rx of regexes) {
        if (rx.test(h)) return i;
      }
    }
    return -1;
  };

  // Staff number (what the search endpoint expects) — prefer columns like "staff", "staff number", "staff_no", "staff number"
  const getStaffNumberFromRow = (row) => {
    const idx = findHeaderIndex([/staff\b/, /staff number/, /staff_no/, /staff no/, /staffnumber/]);
    if (idx !== -1) return row[idx];
    // fallback to legacy index(2)
    return row[2];
  };

  // User id extraction — prefer headers containing "user id" or "user_id"
  const getUserIdFromRow = (row) => {
    const idx = findHeaderIndex([/user id/, /userid/, /user_id/, /user-id/]);
    if (idx !== -1) return row[idx];
    // fallback to index 7 (as earlier code did)
    return row[7];
  };

  // Employee internal id (if somewhere needed) — search for 'employee id' explicitly
  const getEmployeeInternalIdFromRow = (row) => {
    const idx = findHeaderIndex([/employee id/, /emp id/, /employeeid/, /empid/]);
    if (idx !== -1) return row[idx];
    // fallback to index 8 if the newer API placed it there (best-effort)
    return row[8] ?? row[2];
  };

  useEffect(() => {
    if (headers.length > 0) {
      const mustHave = ["Role Code"]; // lock this to always show
      const initial = headers
        // .filter((h) => !mustHave.includes(h) && h !== "Role ID")
        .filter((h) => !mustHave.includes(h) && !["Employee Id", "User Id"].includes(h))
        .slice(0, 5);
      const initialWithMustHave = headers.filter(
        // (h) => (mustHave.includes(h) || initial.includes(h)) && h !== "Role ID"
        (h) =>
          (mustHave.includes(h) || initial.includes(h)) &&
          !["Employee Id", "User Id"].includes(h)
      );

      // ensure the first visible remains first if initialWithMustHave doesn't already include it
      // (but don't change ordering otherwise) — minimal change
      const result = Array.from(new Set(initialWithMustHave));
      setVisibleColumns(result);
    }
  }, [headers]);

  // ---- LOCK: first visible column (minimal changes)
  // lockedColumn is the first element of visibleColumns (if present), otherwise fallback to headers[0]
  const lockedColumn = (Array.isArray(visibleColumns) && visibleColumns.length > 0) ? visibleColumns[0] : headers[0];

  const handleColumnSelection = (column) => {
    // Prevent toggling locked first column and keep Role Code locked
    if (!column) return;
    if (column === lockedColumn) return;
    if (["Role Code"].includes(column)) return; // locked
    if (visibleColumns.includes(column)) {
      setVisibleColumns(visibleColumns.filter((c) => c !== column));
    } else {
      setVisibleColumns([...visibleColumns, column]);
    }
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };

  const handleApplyFilter = () => {
    if (Object.keys(filters).length > 0) {
      setAppliedFilters({ ...filters }); // Persist selected filters
      setCurrentPage(1); // Reset to the first page
      setIsFiltersApplied(true); // Show Reset button
      setIsFilterVisible(false); // Hide the filter sidebar
    }
  };

  const handleResetFilter = () => {
    setFilters({}); // Clear current filter selections
    setAppliedFilters({}); // Clear applied filters
    setAverageRunTime(""); // Reset any other state if required
    setIsFiltersApplied(false); // Deactivate the Reset button
  };

  const handleFilterSelection = (selectedOption, header) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [header]: selectedOption,
    }));

    setIsFilterDropdownSelected(true); // Mark dropdown as interacted
  };

  const filteredData = data.filter((row) => {
    const matchesSearchQuery = row.some(
      (cell) =>
        cell && String(cell).toLowerCase().includes(searchQuery.toLowerCase())
    );
    const matchesAverageRunTime =
      averageRunTime === "" || row[2] === averageRunTime;

    // Apply appliedFilters
    const matchesFilters = Object.entries(appliedFilters).every(
      ([key, value]) => {
        const colIndex = headers.indexOf(key);
        return value ? row[colIndex] === value : true;
      }
    );

    return matchesSearchQuery && matchesAverageRunTime && matchesFilters;
  });

  const handleSort = (column) => {
    let direction = "asc";
    if (sortConfig.key === column && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key: column, direction });
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        columnDropdownRef.current &&
        !columnDropdownRef.current.contains(event.target)
      ) {
        setIsColumnDivVisible(false); // Close the dropdown if clicked outside
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const sortedData = React.useMemo(() => {
    let sortableData = [...filteredData];
    if (sortConfig.key !== null) {
      const colIndex = headers.indexOf(sortConfig.key);
      sortableData.sort((a, b) => {
        const A = a[colIndex];
        const B = b[colIndex];
        if (A < B) return sortConfig.direction === "asc" ? -1 : 1;
        if (A > B) return sortConfig.direction === "asc" ? 1 : -1;
        return 0;
      });
    }
    return sortableData;
  }, [filteredData, sortConfig, headers]);

  const handleExport = (type) => {
    const exportData = sortedData.map((row) =>
      visibleColumns.map((column) => row[headers.indexOf(column)])
    );

    const fileName = prompt("Enter the file name:");
    if (!fileName) return;

    if (type === "excel" || type === "csv") {
      const worksheet = XLSX.utils.aoa_to_sheet([visibleColumns, ...exportData]);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
      const fileExtension = type === "csv" ? "csv" : "xlsx";
      const mimeType =
        type === "csv"
          ? "text/csv"
          : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      const file = XLSX.write(workbook, {
        bookType: fileExtension,
        type: "array",
      });
      const blob = new Blob([file], { type: mimeType });
      FileSaver.saveAs(blob, `${fileName}.${fileExtension}`);
    } else if (type === "pdf") {
      const doc = new jsPDF();
      doc.autoTable({
        head: [visibleColumns],
        body: exportData,
      });
      doc.save(`${fileName}.pdf`);
    }
  };

  const handlePageSizeChange = (size) => {
    setPageSize(size);
    setCurrentPage(1);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const totalPages = Math.ceil(sortedData.length / pageSize);
  const paginatedData = React.useMemo(() => {
    const startIndex = (currentPage - 1) * pageSize;
    return sortedData.slice(startIndex, startIndex + pageSize);
  }, [sortedData, currentPage, pageSize]);

  const renderPagination = () => {
    const pages = [];
    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(
          <button
            key={i}
            onClick={() => handlePageChange(i)}
            style={{ borderRadius: "5px" }}
            className={i === currentPage ? "active" : ""}
          >
            {i}
          </button>
        );
      }
    } else {
      if (currentPage <= 3) {
        for (let i = 1; i <= 3; i++) {
          pages.push(
            <button
              key={i}
              style={{ borderRadius: "5px" }}
              onClick={() => handlePageChange(i)}
              className={i === currentPage ? "active" : ""}
            >
              {i}
            </button>
          );
        }
        pages.push(
          <span style={{ borderRadius: "5px" }} key="dots1">
            ...
          </span>
        );
        pages.push(
          <button
            key={totalPages}
            onClick={() => handlePageChange(totalPages)}
            style={{ borderRadius: "5px" }}
          >
            {totalPages}
          </button>
        );
      } else if (currentPage > 3 && currentPage < totalPages - 2) {
        pages.push(
          <button
            key={1}
            onClick={() => handlePageChange(1)}
            style={{ borderRadius: "5px" }}
          >
            1
          </button>
        );
        pages.push(
          <span style={{ borderRadius: "5px" }} key="dots1">
            ...
          </span>
        );
        for (let i = currentPage - 1; i <= currentPage + 1; i++) {
          pages.push(
            <button
              key={i}
              onClick={() => handlePageChange(i)}
              style={{ borderRadius: "5px" }}
              className={i === currentPage ? "active" : ""}
            >
              {i}
            </button>
          );
        }
        pages.push(
          <span style={{ borderRadius: "5px" }} key="dots2">
            ...
          </span>
        );
        pages.push(
          <button
            key={totalPages}
            onClick={() => handlePageChange(totalPages)}
            style={{ borderRadius: "5px" }}
          >
            {totalPages}
          </button>
        );
      } else {
        pages.push(
          <button
            key={1}
            onClick={() => handlePageChange(1)}
            style={{ borderRadius: "5px" }}
          >
            1
          </button>
        );
        pages.push(
          <span style={{ borderRadius: "5px" }} key="dots1">
            ...
          </span>
        );
        for (let i = totalPages - 2; i <= totalPages; i++) {
          pages.push(
            <button
              key={i}
              onClick={() => handlePageChange(i)}
              style={{ borderRadius: "5px" }}
              className={i === currentPage ? "active" : ""}
            >
              {i}
            </button>
          );
        }
      }
    }
    return pages;
  };

  const handleSelectAll = (e) => {
    if (!bulk) {
      // If not in bulk mode, don't allow selecting all
      return;
    }
    if (e.target.checked) {
      setSelectedRows(data.map((row) => row[0]));
    } else {
      setSelectedRows([]);
    }
  };

  const handleRowSelect = (rowIndex) => {
    const actualIndex = (currentPage - 1) * pageSize + rowIndex;
    const questionId = sortedData[actualIndex][0];

    setSelectedRows((prev) => (prev.includes(questionId) ? [] : [questionId]));
  };

  const handleMouseDown = (event) => {
    isResizing.current = true;
    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
  };

  const handleMouseMove = (event) => {
    if (isResizing.current) {
      const newWidth = Math.max(100, event.clientX - columnRef.current.offsetLeft); // Min width: 100px
      setColumnWidth(newWidth);
    }
  };

  const handleMouseUp = () => {
    isResizing.current = false;
    document.removeEventListener("mousemove", handleMouseMove);
    document.removeEventListener("mouseup", handleMouseUp);
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginTop: "10px",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "82vw",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              border: "1px solid #6A6A6A",
              overflow: "hidden",
            }}
          >
            <input
              type="text"
              placeholder={searchPlaceholder}
              name="search"
              className="search-input-ques-dash"
              onChange={handleSearch}
            />
            <div
              style={{
                width: "1px",
                height: "24px",
                backgroundColor: "#2F2E40",
                margin: "0 4px",
              }}
            ></div>
            <img src={searchicon} alt="search" className="search-icon-ques-dash" />
          </div>
          <div style={{ textAlign: "end", marginTop: "20px", color: "#424242" }}>
            Displaying{" "}
            {Math.min((currentPage - 1) * pageSize + 1, sortedData.length)} -{" "}
            {Math.min(currentPage * pageSize, sortedData.length)} of {sortedData.length} records |
            {["10", "25", "50", "100", "500"].map((size) => (
              <span
                key={size}
                onClick={() => handlePageSizeChange(Number(size))}
                style={{
                  cursor: "pointer",
                  margin: "0 5px",
                  textDecoration: size === pageSize.toString() ? "none" : "underline",
                  color: size === pageSize.toString() ? "black" : "#337AB7",
                }}
              >
                {size}
              </span>
            ))}
          </div>
        </div>
      </div>

      <div
        style={{
          display: "flex",
          backgroundColor: "#D6D6D6",
          marginTop: "9px",
          borderTop: "1px solid grey",
          borderBottom: "1px solid grey",
        }}
      >
        <div
          style={{
            backgroundColor: "#FFBD20",
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
            paddingLeft: "8px",
            width: "90px",
          }}
          onClick={() => setIsFilterVisible(!isFilterVisible)}
        >
          <img src={Filter} style={{ height: "24px", width: "24px" }} alt="filter" />
          <span style={{ marginLeft: "10px", color: "#2F2E40" }}>Filter</span>
        </div>
        <div
          className="col-tc"
          style={{
            marginLeft: "auto",
            textAlign: "end",
            marginRight: "8px",
            display: "flex",
            alignItems: "center",
            position: "relative",
            cursor: "pointer",
            height: "40px",
          }}
          onClick={() => setIsColumnDivVisible(!isColumnDivVisible)}
        >
          <img src={columnaddition} style={{ height: "34px", width: "32px" }} alt="column addition" />
          <span
            style={{
              marginLeft: "4px",
              color: "#2F2E40",
              marginRight: "14px",
              fontSize: "14px",
            }}
          >
            Column Selection
          </span>
          {isColumnDivVisible && (
            <div ref={columnDropdownRef}>
              <div className="arrow-up-tc"></div>
              <div className="popupColumn-tc">
                {headers
                  // .filter((h) => h && h !== "Role ID") // do not offer Role ID
                  .filter((h) => h && !["Employee Id", "User Id"].includes(h))
                  .map((column, index) => {
                    const isLocked = column === lockedColumn || column === "Role Code";

                    return (
                      <div
                        key={index}
                        onClick={(e) => {
                          e.stopPropagation();
                          // don't allow clicks that attempt to toggle a locked column
                          if (isLocked) return;
                          handleColumnSelection(column);
                        }}
                      >
                        <input
                          type="checkbox"
                          id={`column-${index}`}
                          value={column}
                          className="square-checkbox-tc"
                          checked={visibleColumns.includes(column)}
                          disabled={isLocked} // disable toggling the locked column
                          readOnly
                        />
                        <label htmlFor={`column-${index}`}>{column}</label>
                      </div>
                    );
                  })}
              </div>
            </div>
          )}
        </div>
      </div>

      {data.length > 0 ? (
        <>
          <div className="table-container-scrollable">
            <table className="fixed-header-table" style={{ width: "100%" }}>
              <thead>
                <tr>
                  {visibleColumns.map((heading, index) => (
                    <td
                      key={index}
                      ref={index === 1 ? columnRef : null}
                      className={`Heading-tc resizable-header ${index === 1 ? "resizable-header" : ""}`}
                      style={{
                        textAlign: "right",
                        cursor: "pointer",
                        width: index === 1 ? `${columnWidth}px` : "auto",
                        position: "relative",
                      }}
                    >
                      <span
                        style={{
                          display: "flex",
                          alignItems: "left",
                          justifyContent: "left",
                          color: "rgb(47, 46, 64)",
                          fontSize: "14px",
                        }}
                      >
                        {heading}
                        {index === 1 && <div className="resize-handle" onMouseDown={handleMouseDown}></div>}
                        <img
                          onClick={() => handleSort(heading)}
                          src={updown}
                          style={{ height: "20px", width: "20px", marginLeft: "5px" }}
                          alt="sort"
                        />
                      </span>
                    </td>
                  ))}
                </tr>
              </thead>

              <tbody>
                {paginatedData.map((row, rowIndex) => (
                  <tr key={rowIndex} className={rowIndex % 2 === 1 ? "even-row-tc" : ""}>
                    {visibleColumns.map((column, cellIndex) => {
                      const colIndexInHeaders = headers.indexOf(column);
                      // safe fallback if header not found
                      const cellValue = colIndexInHeaders !== -1 ? row[colIndexInHeaders] : "";
                      return (
                        <td
                          key={cellIndex}
                          style={{
                            width: cellIndex === 1 ? `${columnWidth}px` : "auto",
                            textAlign: "left",
                            color: "#6A6A6A",
                            verticalAlign: "middle",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: `${columnWidth}px`,
                          }}
                        >
                          {cellIndex === 0 ? (
                            <div style={{ display: "flex", alignItems: "center" }}>
                              <input
                                type="checkbox"
                                className="delete-question-checkbox-dqc"
                                checked={selectedRows.includes(row[0])}
                                onChange={() => handleRowSelect(rowIndex)}
                                style={{ marginRight: "8px" }}
                              />
                              {/* NAVIGATE passing staff number (search key) and user id */}
                              <Link
                                style={{ color: "#337ab7" }}
                                to={`/user_from_dashboard_edit?MNTQuestionNumbers=${encodeURIComponent(
                                  getStaffNumberFromRow(row)
                                )}&UsernameOfEmployee=${encodeURIComponent(row[0])}&UserID=${encodeURIComponent(
                                  getUserIdFromRow(row)
                                )}`}
                              >
                                <span className="truncated-text" title={cellValue}>
                                  {colIndexInHeaders === 2 ? renderQuestionText(cellValue) : cellValue}
                                </span>
                              </Link>
                            </div>
                          ) : (
                            <span className="truncated-text-2">
                              {colIndexInHeaders === 2 ? renderQuestionText(cellValue) : cellValue}
                            </span>
                          )}
                        </td>
                      );
                    })}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="pagination-tc">
            <button onClick={() => handlePageChange(1)} disabled={currentPage === 1} className="extreme-left-tc-pagination">
              <img src={leftArrow} alt="" />
            </button>
            <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} className="lefttc-pagination">
              {"<"}
            </button>
            {renderPagination()}
            <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} className="righttc-pagination">
              {">"}
            </button>
            <button onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} className="extreme-right-tc-pagination">
              <img src={rightArrow} alt="" />
            </button>
          </div>
        </>
      ) : (
        "No data available"
      )}

      {isFilterVisible && (
        <div className="filter-sidebar-tc">
          <div className="filter-content-tc" style={{ position: "relative" }}>
            <button className="repman-cross-btn-HOD" onClick={() => setIsFilterVisible(false)}>
              <p>X</p>
            </button>
            <h3 className="AdvanceF-heading-tc"> Filter</h3>
            <div className="filter-apply-reset-ques-rev-dash">
              <button className="create-test-section-btn" onClick={handleApplyFilter}>
                APPLY
              </button>
              {isFiltersApplied && (
                <button className="create-test-section-btn" onClick={handleResetFilter}>
                  RESET
                </button>
              )}
            </div>
            <div className="filter-options-container">
              {headers
                // .filter((_, index) => index !== 0) // Skip only index 0
                .filter((header) => header && !["Employee Id", "User Id"].includes(header))
                .map((header, filteredIndex) => {
                  const originalIndex = filteredIndex + 1; // Shift by 1 because we skipped index 0

                  let uniqueOptions = [
                    ...new Set(data.map((row) => row[originalIndex]).filter((option) => option)),
                  ];

                  // Sort index 1 and index 6 in ascending order (adjust if needed)
                  if (originalIndex === 1 || originalIndex === 6) {
                    uniqueOptions.sort((a, b) => (a > b ? 1 : -1));
                  }

                  return (
                    <SelectedValuesDropdown
                      key={originalIndex}
                      label={header}
                      width="300px"
                      marginLeft="15px"
                      marginTop="18px"
                      setSelected={(selectedOption) => {
                        setFilters((prevFilters) => ({
                          ...prevFilters,
                          [header]: selectedOption, // Update the filters state
                        }));
                      }}
                      options={uniqueOptions.map((value) => ({
                        label: value,
                        id: value,
                      }))}
                      selected={filters[header] || ""} // Show selected filter if present
                      Height="auto"
                      OverFlow="auto"
                      minheight="200px"
                    />
                  );
                })}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserGroupsManagementTable;


